// Match the existing selected heartbeat; at most two immediate snapshots per loss interval.
export const SELECTED_CONTINUITY_POLICY = Object.freeze({
  recoveryTimeoutMs: 5000,
  transportAckTimeoutMs: 2000,
  retryIntervalMs: 25000,
  maxBurstAttempts: 2,
});
